import { Grid2 } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { EnrichmentGeneralOverviewResultsProps as Props } from './types';
import { CompletenessScore } from '../completeness-score';
import { RecordsEnriched } from '../records-enriched';
import { EnrichmentReportCard } from '../enrichment-report-card';

export const EnrichmentGeneralOverviewResults = memo(({ className }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('GeneralOverviewResults', className)}
      sx={SX.root}
    >
      <EnrichmentReportCard title="General Overview Results">
        <Grid2 container columns={48} sx={SX.content} columnSpacing={1.6}>
          <Grid2 xs={17}>
            <RecordsEnriched />
          </Grid2>
          <Grid2 xs={31}>
            <CompletenessScore />
          </Grid2>
        </Grid2>
      </EnrichmentReportCard>
    </Styled.Wrapper>
  );
});

EnrichmentGeneralOverviewResults.displayName =
  'EnrichmentGeneralOverviewResults';
